import { styled } from "@mui/system";

const grey = {
    50: "#f6f8fa",
    200: "#d0d7de",
    500: "#6e7781",
    700: "#424a53",
    900: "#24292f",
  };
  
  const blue = {
    500: "#007FFF",
    600: "#0072E5",
    700: "#0059B2",
  };
  
  export const PopupBody = styled("div")(
    ({ theme }) => `
    width: max-content;
    padding: 12px 16px;
    margin: 8px;
    border-radius: 8px;
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    background-color: ${theme.palette.mode === "dark" ? grey[900] : grey[50]};
    box-shadow: ${
      theme.palette.mode === "dark"
        ? `0px 4px 8px rgb(0 0 0 / 0.7)`
        : `0px 4px 8px rgb(0 0 0 / 0.1)`
    };
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: 0.875rem;
    z-index: 1;
  `
  );

  